import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'Community',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  data () {
    return {
      loading: true,
      registerHash: Constants.RegisterHash,
      
      // テーブルオプション
      tableColumns: [
        'createdAt',
        'name',
        'tenant',
        'communityTantous',
        'deviceTypes',
        'status',
        'detailButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          createdAt: '登録年月日',
          name: 'コミュニティ名',
          tenant: 'テナント',
          communityTantous: 'コミュニティ担当者',
          deviceTypes: '登録品番',
          status: 'ステータス',
          detailButton: ''
        },
        columnsClasses: {
          createdAt: 'wp-10',
          name: '',
          tenant: '',
          communityTantous: '',
          deviceTypes: '',
          status: '',
          detailButton: 'wp-5 has-button'
        },
        sortable: [
          'createdAt',
          'name',
          'tenant',
          'communityTantous',
          'status'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts(this.categoryName),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // // 検索
      // searchCommunityName: null,
      // searchTenantName: null,
      // searchStatus: '',

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    this.init()
  },
  beforeDestroy() {
    if (this.$route.name !== 'CommunityDetail') {
      this.reset()
    }
  },
  computed: {
    ...mapState({
      categoryName: state => state.community.categoryName,
      communityModel: state => state.community.communityModel,
      syncProccesing: state => state.admp.proccesing,

      // 検索
      filters: state => state.community.filters,
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone'
    }),

    loadingDescription () {
      return this.syncProccesing
        ? 'ADMP同期中'
        : ''
    },

    // list
    statusList () {
      return Constants.Status.sort(Utility.sortByKey('index', true))
    },
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // filter
    searchCommunityName: {
      get () {
        return this.filters.searchCommunityName
      },
      set (value) {
        this.setInputFilter({
          key: 'searchCommunityName',
          value: value
        })
      }
    },
    searchTenantName: {
      get () {
        return this.filters.searchTenantName
      },
      set (value) {
        this.setInputFilter({
          key: 'searchTenantName',
          value: value
        })
      }
    },
    searchStatus: {
      get () {
        return this.filters.searchStatus
      },
      set (value) {
        this.setInputFilter({
          key: 'searchStatus',
          value: value
        })
      }
    },
  },
  watch: {
    syncProccesing: function (to) {
      if (!to) {
        this.init()
      }
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      loadModel: 'community/loadModel',
      loadCommunityList: 'community/loadCommunityList',
      syncAdmp: 'admp/sync',
      reset: 'community/reset'
    }),
    ...mapMutations({
      setInputFilter: 'community/setInputFilter',
    }),

    init () {
      this.loading = true

      // データ検索パラメータ
      let communityParams = { filters: {} }
      if (this.searchCommunityName)
        communityParams.filters.communityName = this.searchCommunityName
      if (this.searchTenantName)
        communityParams.filters.tenantName = this.searchTenantName
      if (this.searchStatus !== '')
        communityParams.filters.communityStatus = this.searchStatus
      let tenantParams = { filters: {} }

      // データ読出し
      this.loadModel({
        communityParams: communityParams,
        tenantParams: tenantParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.communityModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'createdAt':
          return Utility.dateFormat(value, 'YYYY/MM/DD')
        case 'tenant':
          return props.row[key].name
        case 'communityTantous':
          return props.row[key].length
            ? props.row[key].map(item => item.name).join('、')
            : Constants.BlankValue
        case 'deviceTypes':
          return props.row[key].map(item => item.modelNumber).join('、')
        case 'status':
          return Utility.getConstantsLabel(['Status'], value)
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 検索
    resetSearch () {
      this.searchCommunityName = null
      this.searchTenantName = null
      this.searchStatus = ''

      this.init()
    },
    search () {
      this.loading = true

      // データ検索パラメータ
      let communityParams = { filters: {} }
      if (this.searchCommunityName)
        communityParams.filters.communityName = this.searchCommunityName
      if (this.searchTenantName)
        communityParams.filters.tenantName = this.searchTenantName
      if (this.searchStatus !== '')
        communityParams.filters.communityStatus = this.searchStatus

      // データ読出し
      this.loadCommunityList({
        communityParams: communityParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.communityModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    detailItem (props) {
      this.$router.push({
        name: 'CommunityDetail',
        params: {
          communityId: String(props.row.communityUuid)
        }
      })
    },
  }
}